const translations = {
    headerTitle: {
        type: 'text',
        defaultValue: '<b>Witaj</b> w Rehab',
    },
    headerDescription: {
        type: 'text',
        defaultValue: 'Aby otrzymać dostęp do platformy Rehab, prosimy o wypełnienie poniższego formularza rejestracyjnego. Po jego wypełnieniu powiadomimy Cię mailowo o kolejnych etapach rejestracji.',
    },
    titleCompany: {
        type: 'text',
        defaultValue: 'Dane firmy:',
    },
    titlePerson: {
        type: 'text',
        defaultValue: 'Dane osobowe:',
    },
    inputCompanyName: {
        type: 'text',
        defaultValue: 'Nazwa firmy',
    },
    inputVatId: {
        type: 'text',
        defaultValue: 'NIP firmy',
    },
    inputCity: {
        type: 'text',
        defaultValue: 'Miasto',
    },
    inputPostCode: {
        type: 'text',
        defaultValue: 'Kod pocztowy',
    },
    inputStreet: {
        type: 'text',
        defaultValue: 'Ulica',
    },
    inputHomeNo: {
        type: 'text',
        defaultValue: 'Numer domu',
    },
    inputFlatNo: {
        type: 'text',
        defaultValue: 'Numer lokalu',
    },
    inputFirstName: {
        type: 'text',
        defaultValue: 'Imię',
    },
    inputLastName: {
        type: 'text',
        defaultValue: 'Nazwisko',
    },
    inputEmail: {
        type: 'text',
        defaultValue: 'Email',
    },
    inputPhone: {
        type: 'text',
        defaultValue: 'Telefon',
    },
    submitButton: {
        type: 'text',
        defaultValue: 'Zarejestruj się',
    },
    resultFormTitle: {
        type: 'text',
        defaultValue: 'Dziękujemy!',
    },
    resultFormDescription: {
        type: 'text',
        defaultValue: 'Dziękujemy za wypełnienie formularza rejestracyjnego. Twoja prośba o rejestrację została przekazana do naszego administratora. <br/><br/> O kolejnych krokach powiadomimy Cię mailowo.',
    },
    resultFormButton: {
        type: 'text',
        defaultValue: 'Wróć do strony główej',
    },
};

export default translations;
